
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dZUkS", function(module, exports) {
/**
 * Snippets Store - Centralized State Management
 *
 * This module provides a centralized store for managing snippets data
 * using react-sweet-state. This replaces the previous pattern of individual hooks
 * (useCreateSnippet, useFetchSnippets) with a single source of truth.
 *
 * Usage:
 * - Wrap your app with <SnippetsProvider> to trigger initial fetch
 * - Use useSnippetsState() for read-only state access
 * - Use useSnippetsActions() when you need to dispatch actions
 * - Use useSnippets() when you need both state and actions
 */ 
var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4HDYO = parcelRequire("4HDYO");


var $ebSlI = parcelRequire("ebSlI");


var $a6kUr = parcelRequire("a6kUr");

/**
 * Module-level registry for one-time callbacks that fire when the current in-flight fetch completes.
 * These callbacks are cleared after each fetch completes and are NOT triggered by future fetches.
 */ let $bc4bb1bc094c1f8d$var$pendingLoadCallbacks = [];
const $bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e = (0, $1P1Tu.createStore)({
    initialState: (0, $ebSlI.getInitialState)(),
    actions: $a6kUr.actions,
    name: 'SnippetsStore'
});
const $bc4bb1bc094c1f8d$export$f6df4e69084aa09f = (0, $9zUhf.createHook)($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
const $bc4bb1bc094c1f8d$export$bc515607f82ac38d = (0, $9zUhf.createActionsHook)($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
const $bc4bb1bc094c1f8d$export$d2573ca28cf6a6de = (0, $9zUhf.createStateHook)($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
const $bc4bb1bc094c1f8d$export$9211bc7cf74ad61b = ()=>{
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
    return storeInstance.storeState.getState();
};
const $bc4bb1bc094c1f8d$export$cf5f21fefd1a9a8a = (callback)=>{
    $bc4bb1bc094c1f8d$var$pendingLoadCallbacks.push(callback);
};
const $bc4bb1bc094c1f8d$export$3ce7f1b7cae8932a = (snippets)=>{
    const callbacks = $bc4bb1bc094c1f8d$var$pendingLoadCallbacks;
    $bc4bb1bc094c1f8d$var$pendingLoadCallbacks = []; // Clear before invoking to prevent re-registration issues
    callbacks.forEach((cb)=>cb(snippets));
};
module.exports["useSnippets"] = $bc4bb1bc094c1f8d$export$f6df4e69084aa09f;
module.exports["useSnippetsActions"] = $bc4bb1bc094c1f8d$export$bc515607f82ac38d;
module.exports["getSnippetsStateSnapshot"] = $bc4bb1bc094c1f8d$export$9211bc7cf74ad61b;
module.exports["onCurrentFetchComplete"] = $bc4bb1bc094c1f8d$export$cf5f21fefd1a9a8a;
module.exports["invokePendingLoadCallbacks"] = $bc4bb1bc094c1f8d$export$3ce7f1b7cae8932a;

});

parcelRegister("ebSlI", function(module, exports) {
/**
 * Snippets Store Types
 *
 * Defines the shape of the centralized snippets state for managing snippets data.
 * The `isLoaded` flag is crucial for preventing duplicate fetch requests -
 * once snippets are loaded, subsequent calls to fetchSnippets() will return
 * the cached data immediately.
 *
 * Error state:
 * - `fetchError`: Set when fetching snippets fails
 */ const $523eaf9335c60db8$export$53ac33307b5acee9 = ()=>({
        snippets: [],
        isLoading: false,
        fetchError: null,
        isLoaded: false
    });
module.exports["getInitialState"] = $523eaf9335c60db8$export$53ac33307b5acee9;

});

parcelRegister("a6kUr", function(module, exports) {

var $5NAso = parcelRequire("5NAso");


var $kZ6BG = parcelRequire("kZ6BG");


var $2Qxf3 = parcelRequire("2Qxf3");


var $cfxyE = parcelRequire("cfxyE");

const $211e3bb4477563d9$export$e324594224ef24da = {
    ...(0, $2Qxf3.fetchActions),
    ...(0, $5NAso.createActions),
    ...(0, $kZ6BG.deleteActions),
    ...(0, $cfxyE.updateActions)
};
module.exports["actions"] = $211e3bb4477563d9$export$e324594224ef24da;

});

parcelRegister("5NAso", function(module, exports) {
/**
 * Create Actions - Snippet creation with UI integration
 *
 * This action handles snippet creation with full UI integration:
 * - Creates the snippet via the API
 * - Shows success/error flags
 * - Adds the snippet to the editor's quick insert menu
 * - Refreshes the snippets list
 *
 * Separated from fetchActions because it has UI dependencies (flags, intl, editor API)
 * that the pure data operations don't need.
 */ 
var $jU9SA = parcelRequire("jU9SA");


var $jwG9y = parcelRequire("jwG9y");


var $3e10B = parcelRequire("3e10B");


var $3kq4s = parcelRequire("3kq4s");


var $e9jnk = parcelRequire("e9jnk");


var $eINu6 = parcelRequire("eINu6");


var $edTDY = parcelRequire("edTDY");

const $d34b4d835ec45f27$export$aad2e27b28b19174 = {
    /**
   * Creates a new snippet and refreshes the snippets list.
   *
   * After successful creation:
   * - Clears the service cache and fetches the updated list
   * - Shows a success flag (if options provided)
   * - Adds the snippet to the quick insert menu
   *
   * On error:
   * - Reports to monitoring
   * - Shows an error flag (if options provided)
   * - Keeps existing snippets visible (doesn't reset isLoaded)
   *
   * @param name - The snippet name (required)
   * @param body - The ADF content body
   * @param description - Optional description text
   * @param options - UI options including flags, intl, and editor API ref
   * @returns Promise resolving to the newly created snippet, or null on failure
   */ createSnippet: (name, body, description, options)=>async ({ setState: setState })=>{
            const descriptionValue = description?.trim();
            const params = {
                name: name,
                ...descriptionValue && {
                    description: descriptionValue
                },
                body: JSON.stringify(body),
                bodyFormat: (0, $e9jnk.SnippetBodyFormat).ADF,
                product: (0, $e9jnk.SnippetProduct).CONFLUENCE
            };
            setState({
                isLoading: true
            });
            try {
                const snippet = await $3e10B.createSnippet(params);
                (0, $3kq4s.clearSnippetsCache)();
                const updatedSnippets = await $3e10B.fetchSnippets();
                setState({
                    snippets: updatedSnippets,
                    isLoading: false,
                    isLoaded: true
                });
                if (options) {
                    const { flags: flags, intl: intl, editorAPI: editorAPI } = options;
                    (0, $edTDY.showSnippetSuccessFlag)(flags, intl.formatMessage((0, $jU9SA.messages).createTemplateModalSuccessFlagTitle, {
                        snippetName: snippet.name
                    }), intl.formatMessage((0, $jU9SA.messages).createTemplateModalSuccessFlagDescription));
                    if (editorAPI) (0, $jwG9y.addSnippetQuickInsertItemWithAPI)({
                        snippet: snippet,
                        editorAPI: editorAPI
                    });
                }
                return snippet;
            } catch (thrownError) {
                const err = thrownError instanceof Error ? thrownError : new Error(String(thrownError));
                setState({
                    isLoading: false
                });
                (0, $eINu6.reportError)(err);
                if (options) {
                    (0, $edTDY.showSnippetErrorFlag)(options.flags, options.intl.formatMessage((0, $jU9SA.messages).createTemplateModalErrorFlagTitle), options.intl.formatMessage((0, $jU9SA.messages).createTemplateModalErrorFlagDescription));
                    return null;
                }
                throw err;
            }
        }
};
module.exports["createActions"] = $d34b4d835ec45f27$export$aad2e27b28b19174;

});

parcelRegister("jU9SA", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $9c872498afbde1b3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    createTemplateModalTitle: {
        id: "snippets.createTemplateModalTitle",
        defaultMessage: "Create template"
    },
    createTemplateModalDescription: {
        id: "snippets.createTemplateModalDescription",
        defaultMessage: "Save content and easily reuse it through / menu."
    },
    createTemplateModalNamePlaceholder: {
        id: "snippets.createTemplateModalNamePlaceholder",
        defaultMessage: "Enter template name"
    },
    createTemplateModalNameLabel: {
        id: "snippets.createTemplateModalNameLabel",
        defaultMessage: "Name"
    },
    createTemplateModalNameHelper: {
        id: "snippets.createTemplateModalNameHelper",
        defaultMessage: "Use a name to find your Block Template"
    },
    createTemplateModalNameError: {
        id: "snippets.createTemplateModalNameError",
        defaultMessage: "Name is required"
    },
    createTemplateModalDescriptionLabel: {
        id: "snippets.createTemplateModalDescriptionLabel",
        defaultMessage: "Description"
    },
    createTemplateModalDescriptionPlaceholder: {
        id: "snippets.createTemplateModalDescriptionPlaceholder",
        defaultMessage: "Enter template description"
    },
    createTemplateModalAdfError: {
        id: "snippets.createTemplateModalAdfError",
        defaultMessage: "Something went wrong, please make a new content selection"
    },
    createTemplateModalCancelButton: {
        id: "snippets.createTemplateModalCancelButton",
        defaultMessage: "Cancel"
    },
    createTemplateModalCreateButton: {
        id: "snippets.createTemplateModalCreateButton",
        defaultMessage: "Create"
    },
    createTemplateModalErrorFlagTitle: {
        id: "snippets.createTemplateModalErrorFlagTitle",
        defaultMessage: "Could not create template"
    },
    createTemplateModalErrorFlagDescription: {
        id: "snippets.createTemplateModalErrorFlagDescription",
        defaultMessage: "Please try again"
    },
    createTemplateModalSuccessFlagTitle: {
        id: "snippets.createTemplateModalSuccessFlagTitle",
        defaultMessage: "Template \"{snippetName}\" created"
    },
    createTemplateModalSuccessFlagDescription: {
        id: "snippets.createTemplateModalSuccessFlagDescription",
        defaultMessage: "You can now use it from the / menu"
    }
});
module.exports["messages"] = $9c872498afbde1b3$export$defe85febe8b728c;

});

parcelRegister("jwG9y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5SAOw = parcelRequire("5SAOw");


var $jdPfT = parcelRequire("jdPfT");


var $4MPLO = parcelRequire("4MPLO");

const $dc8a26cf89389c81$export$a72e587fbb595114 = ({ snippet: snippet, editorAPIRef: editorAPIRef })=>{
    if (!editorAPIRef?.current) return;
    $dc8a26cf89389c81$export$ce60ef8f3e5158f({
        snippet: snippet,
        editorAPI: editorAPIRef.current
    });
};
const $dc8a26cf89389c81$export$ce60ef8f3e5158f = ({ snippet: snippet, editorAPI: editorAPI })=>{
    if (!editorAPI) return;
    const addQuickInsertItem = editorAPI?.quickInsert?.commands?.addQuickInsertItem;
    if (addQuickInsertItem === undefined) return;
    editorAPI.core?.actions.execute(addQuickInsertItem((intl)=>[
            $dc8a26cf89389c81$var$createSnippetQuickInsertItem({
                snippet: snippet,
                intl: intl
            })
        ]));
};
const $dc8a26cf89389c81$var$createSnippetQuickInsertItem = ({ snippet: snippet, intl: intl })=>{
    return {
        key: `snippet-extension:snippet-${snippet.snippetId}`,
        title: snippet.name,
        description: (0, $4MPLO.createSnippetDescription)(snippet.createdBy, intl),
        keywords: (0, $4MPLO.extractSnippetKeywords)(snippet.name, intl),
        isDisabledOffline: true,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
                label: "Snippet"
            }),
        action: (insert, state)=>{
            const body = snippet.body;
            if (!body) return false;
            if (Array.isArray(body)) {
                const fragment = (0, $5SAOw.Fragment).fromJSON(state.schema, body);
                return insert(fragment);
            }
            return insert(body);
        }
    };
};
module.exports["addSnippetQuickInsertItemWithAPI"] = $dc8a26cf89389c81$export$ce60ef8f3e5158f;

});

parcelRegister("4MPLO", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $ea21f85c6ae0b9ea$var$messages = (0, $cgtv4.defineMessages)({
    snippetBy: {
        id: "snippets.quick-insert.by",
        defaultMessage: "by {name}"
    },
    template: {
        id: "snippets.quick-insert.template",
        defaultMessage: "template"
    }
});
function $ea21f85c6ae0b9ea$var$filterValidAdfNodes(nodes) {
    return nodes.filter((node)=>node !== undefined && node !== null);
}
const $ea21f85c6ae0b9ea$export$4cb5aec6fe7a20df = (content)=>{
    try {
        const parsedContent = JSON.parse(content);
        // Handle fragment (array of nodes without doc wrapper)
        if (Array.isArray(parsedContent)) return $ea21f85c6ae0b9ea$var$filterValidAdfNodes(parsedContent);
        // Handle single node or doc node
        const adfContent = parsedContent;
        if (adfContent.type === 'doc' && Array.isArray(adfContent.content)) return $ea21f85c6ae0b9ea$var$filterValidAdfNodes(adfContent.content);
        return adfContent;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error processing snippet ADF:', error);
        return undefined;
    }
};
const $ea21f85c6ae0b9ea$export$fefb8fa12cc0572f = (name, intl)=>{
    const nameKeywords = name.split(/\s+/).map((word)=>word.toLowerCase().trim()).filter((word)=>word.length > 0);
    const templateKeyword = intl.formatMessage($ea21f85c6ae0b9ea$var$messages.template).toLowerCase();
    const allKeywords = [
        ...nameKeywords,
        templateKeyword
    ];
    return Array.from(new Set(allKeywords));
};
const $ea21f85c6ae0b9ea$export$4a4fbbff52147a2b = (createdBy, intl)=>{
    const name = createdBy.displayName || createdBy.accountId;
    return intl.formatMessage($ea21f85c6ae0b9ea$var$messages.snippetBy, {
        name: name
    });
};
const $ea21f85c6ae0b9ea$export$12649e099d1966de = (adf)=>{
    const content = Array.isArray(adf) ? adf : [
        adf
    ];
    return {
        version: 1,
        type: 'doc',
        content: content
    };
};
module.exports["parseSnippetContent"] = $ea21f85c6ae0b9ea$export$4cb5aec6fe7a20df;
module.exports["extractSnippetKeywords"] = $ea21f85c6ae0b9ea$export$fefb8fa12cc0572f;
module.exports["createSnippetDescription"] = $ea21f85c6ae0b9ea$export$4a4fbbff52147a2b;
module.exports["wrapAdfWithDocNode"] = $ea21f85c6ae0b9ea$export$12649e099d1966de;

});

parcelRegister("3e10B", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $e9jnk = parcelRequire("e9jnk");


var $eINu6 = parcelRequire("eINu6");


var $frUcB = parcelRequire("frUcB");


var $lTBQ9 = parcelRequire("lTBQ9");


var $3kq4s = parcelRequire("3kq4s");

const $08eb629ddb2e8bad$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL = '/gateway/api/blocks/v1';
const $08eb629ddb2e8bad$var$SNIPPETS_PATH = '/snippets';
const $08eb629ddb2e8bad$export$424a614da735364c = ()=>{
    return (0, $3kq4s.withSnippetsCache)(async ()=>{
        const [userSnippetsResult, globalSnippetsResult] = await Promise.allSettled([
            $08eb629ddb2e8bad$var$fetchSnippetData('user'),
            $08eb629ddb2e8bad$var$fetchSnippetData('global')
        ]);
        const successfulSnippets = [];
        if (userSnippetsResult.status === 'fulfilled') successfulSnippets.push(...userSnippetsResult.value);
        else $08eb629ddb2e8bad$var$logResultError(userSnippetsResult.reason, 'user');
        if (globalSnippetsResult.status === 'fulfilled') successfulSnippets.push(...globalSnippetsResult.value);
        else $08eb629ddb2e8bad$var$logResultError(globalSnippetsResult.reason, 'global');
        return (0, $lTBQ9.transformSnippets)(successfulSnippets);
    });
};
const $08eb629ddb2e8bad$var$fetchSnippetData = async (scope)=>{
    const params = new URLSearchParams({
        format: (0, $e9jnk.SnippetBodyFormat).ADF,
        product: (0, $e9jnk.SnippetProduct).CONFLUENCE,
        scope: scope
    });
    const response = await (0, $f7B1p.cfetch)(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}?${params.toString()}`, {
        method: 'GET',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
    if (!response.ok) throw new (0, $frUcB.SnippetError)(response.statusText);
    const responseData = await response.json();
    if (!responseData.success) return [];
    // Success and error can both be present, so we need to log the error if it is present
    if (Array.isArray(responseData.error) && responseData.error.length > 0) responseData.error.forEach((error)=>{
        $08eb629ddb2e8bad$var$logResultError(error, scope);
    });
    return responseData.success;
};
const $08eb629ddb2e8bad$export$f7bed3a90241a88a = async (params)=>{
    const response = await (0, $f7B1p.cfetch)(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS,
        body: JSON.stringify(params)
    });
    if (!response.ok) throw new (0, $frUcB.SnippetError)(response.statusText);
    const responseData = await response.json();
    const snippet = await (0, $lTBQ9.transformSnippet)(responseData);
    // Clear the cache so the newly created snippet appears when fetching snippets again
    // (e.g., when navigating to a different page or when the extension provider rebuilds)
    // addSnippetQuickInsertItem only adds it to current editor instance's quick insert menu
    // navigating to a new edit page the extension providers rebuilds and call fetchSnippets which will return the cached data.
    (0, $3kq4s.clearSnippetsCache)();
    if (snippet) return snippet;
    else throw new Error('Unable to transform snippet data after creation');
};
const $08eb629ddb2e8bad$export$ba93a91dd8596775 = async (snippetId)=>{
    const response = await (0, $f7B1p.cfetch)(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}`, {
        method: 'DELETE',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
    if (!response.ok) throw new (0, $frUcB.SnippetError)(response.statusText);
};
const $08eb629ddb2e8bad$export$23a793f970583236 = async (snippetId, snippetPayload)=>{
    const response = await (0, $f7B1p.cfetch)(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}`, {
        method: 'PUT',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS,
        body: JSON.stringify(snippetPayload)
    });
    if (!response.ok) throw new (0, $frUcB.SnippetError)(response.statusText);
    const responseData = await response.json();
    const snippet = await (0, $lTBQ9.transformSnippet)(responseData);
    // Clear the cache so the updated snippet appears when fetching snippets again
    // (e.g., when navigating to a different page or when the extension provider rebuilds)
    (0, $3kq4s.clearSnippetsCache)();
    if (snippet) return snippet;
    else throw new Error('Unable to transform snippet data after update');
};
const $08eb629ddb2e8bad$var$logResultError = (reason, scope)=>{
    const reasonString = reason instanceof Error ? reason.message : JSON.stringify(reason);
    const errorToLog = new Error(`Error when fetching ${scope} scoped snippets: ${reasonString}`);
    (0, $eINu6.reportError)(errorToLog);
};
module.exports["fetchSnippets"] = $08eb629ddb2e8bad$export$424a614da735364c;
module.exports["createSnippet"] = $08eb629ddb2e8bad$export$f7bed3a90241a88a;
module.exports["deleteSnippet"] = $08eb629ddb2e8bad$export$ba93a91dd8596775;
module.exports["updateSnippet"] = $08eb629ddb2e8bad$export$23a793f970583236;

});

parcelRegister("e9jnk", function(module, exports) {
var $9a53cc3a2d654f6a$export$e6769779009a1fa2 = /*#__PURE__*/ function(SnippetProduct) {
    // Only Confluence is allowed currently but more will be added:
    // 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
    SnippetProduct["CONFLUENCE"] = "CONFLUENCE";
    return SnippetProduct;
}({});
var $9a53cc3a2d654f6a$export$4b7b09c17f5ba341 = /*#__PURE__*/ function(SnippetBodyFormat) {
    // Only ADF is allowed currently but more will be added:
    // 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
    SnippetBodyFormat["ADF"] = "ADF";
    return SnippetBodyFormat;
}({});
var $9a53cc3a2d654f6a$export$9826bdf5a11e7016 = /*#__PURE__*/ function(SnippetStatus) {
    SnippetStatus["ACTIVE"] = "active";
    SnippetStatus["DELETED"] = "deleted";
    return SnippetStatus;
}({});
var $9a53cc3a2d654f6a$export$a6855d403c8f3ab5 = /*#__PURE__*/ function(SnippetEditorModalMode) {
    SnippetEditorModalMode["CREATE"] = "create";
    SnippetEditorModalMode["EDIT"] = "edit";
    return SnippetEditorModalMode;
}({});
const $9a53cc3a2d654f6a$export$7f38f8cc01c20d32 = 'atlassian';
module.exports["SnippetProduct"] = $9a53cc3a2d654f6a$export$e6769779009a1fa2;
module.exports["SnippetBodyFormat"] = $9a53cc3a2d654f6a$export$4b7b09c17f5ba341;
module.exports["SnippetEditorModalMode"] = $9a53cc3a2d654f6a$export$a6855d403c8f3ab5;
module.exports["ATLASSIAN_ACCOUNT_ID"] = $9a53cc3a2d654f6a$export$7f38f8cc01c20d32;

});

parcelRegister("eINu6", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $39a9d8105a319c33$export$b33b857ad1d9900e = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
};
module.exports["reportError"] = $39a9d8105a319c33$export$b33b857ad1d9900e;

});

parcelRegister("frUcB", function(module, exports) {
class $0a8fa2d6489c278d$export$e48d728925b396bf extends Error {
    constructor(message){
        super(`Snippet error: ${message}`);
    }
}
module.exports["SnippetError"] = $0a8fa2d6489c278d$export$e48d728925b396bf;

});

parcelRegister("lTBQ9", function(module, exports) {

var $3fxwO = parcelRequire("3fxwO");


var $ge2sX = parcelRequire("ge2sX");


var $eINu6 = parcelRequire("eINu6");


var $e9jnk = parcelRequire("e9jnk");


var $4MPLO = parcelRequire("4MPLO");


var $1KY81 = parcelRequire("1KY81");

const $cd2d5d768dc81da2$export$e7219ab2842dfbd2 = async (snippets)=>{
    const { userId: userId, displayName: displayName } = await (0, $ge2sX.getSessionData)();
    const currentUser = await $cd2d5d768dc81da2$var$getSnippetOwner(userId, displayName);
    return snippets.map((snippet)=>$cd2d5d768dc81da2$export$ced375e1f34774a8(snippet, displayName, currentUser)).filter((snippet)=>snippet !== undefined);
};
const $cd2d5d768dc81da2$export$27f6ce18fbe7c295 = async (snippet)=>{
    const { userId: userId, displayName: displayName } = await (0, $ge2sX.getSessionData)();
    const currentUser = await $cd2d5d768dc81da2$var$getSnippetOwner(userId, displayName);
    return $cd2d5d768dc81da2$export$ced375e1f34774a8(snippet, displayName, currentUser);
};
const $cd2d5d768dc81da2$export$ced375e1f34774a8 = (snippet, displayName, currentUser)=>{
    const parsedBody = (0, $4MPLO.parseSnippetContent)(snippet.body);
    if (parsedBody === undefined) return undefined;
    const isAtlassianCreated = snippet.createdBy?.toLowerCase() === (0, $e9jnk.ATLASSIAN_ACCOUNT_ID);
    const createdByUser = currentUser ?? $cd2d5d768dc81da2$var$getDefaultUserInfo(snippet.createdBy, displayName);
    const createdBy = isAtlassianCreated ? {
        accountId: (0, $e9jnk.ATLASSIAN_ACCOUNT_ID),
        displayName: 'Atlassian'
    } : createdByUser;
    return {
        ari: (0, $3fxwO.BlocksSnippetAri).parse(snippet.resourceId),
        snippetId: snippet.snippetId,
        name: snippet.name,
        description: snippet.description,
        bodyFormat: snippet.bodyFormat,
        body: parsedBody,
        product: snippet.product,
        isFavorite: Boolean(snippet.isFavorite),
        status: snippet.status,
        createdBy: createdBy,
        createdAt: new Date(Number(snippet.createdAt)),
        updatedAt: new Date(Number(snippet.updatedAt))
    };
};
const $cd2d5d768dc81da2$var$getSnippetOwner = async (userId, displayName)=>{
    if (userId) {
        const user = await (0, $1KY81.fetchUserInfo)(userId);
        if (user) return {
            accountId: user.accountId,
            displayName: user.displayName ?? displayName ?? user.accountId,
            avatarUrl: user.avatarUrl ?? $cd2d5d768dc81da2$var$getDefaultUserAvatarUrl(user.accountId)
        };
    }
    $cd2d5d768dc81da2$var$logNoCurrentUser();
};
const $cd2d5d768dc81da2$var$getDefaultUserInfo = (userId, displayName)=>{
    return {
        accountId: userId,
        displayName: displayName ?? userId,
        avatarUrl: $cd2d5d768dc81da2$var$getDefaultUserAvatarUrl(userId)
    };
};
const $cd2d5d768dc81da2$var$getDefaultUserAvatarUrl = (userId)=>{
    return `/wiki/aa-avatar/${encodeURIComponent(userId)}`;
};
const $cd2d5d768dc81da2$var$logNoCurrentUser = ()=>{
    const log = new Error(`No current user found when fetching snippet owner details`);
    (0, $eINu6.reportError)(log);
};
module.exports["transformSnippets"] = $cd2d5d768dc81da2$export$e7219ab2842dfbd2;
module.exports["transformSnippet"] = $cd2d5d768dc81da2$export$27f6ce18fbe7c295;

});

parcelRegister("3fxwO", function(module, exports) {

var $l3omf = parcelRequire("l3omf");


var $3NXcb = parcelRequire("3NXcb");


var $6yCpa = parcelRequire("6yCpa");

// src/blocks/snippet/manifest.ts
var $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $l3omf.BlocksSnippetAriResourceOwner),
    resourceType: (0, $l3omf.BlocksSnippetAriResourceType),
    resourceIdSlug: "workspace/{workspaceId}/{snippetId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        snippetId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-7][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/blocks/snippet/index.ts
var $25dcc7d0ac4036c1$export$7140b52dd9778730 = class _BlocksSnippetAri extends (0, $3NXcb.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get workspaceId() {
        return this._workspaceId;
    }
    get snippetId() {
        return this._snippetId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.qualifier,
            platformQualifier: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.resourceOwner,
            resourceType: $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts.resourceType,
            resourceId: `workspace/${opts.workspaceId}/${opts.snippetId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                snippetId: opts.snippetId
            }
        }, ariOpts = (0, $6yCpa.AriParser).fromOpts(derivedOpts, $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts);
        return new _BlocksSnippetAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $6yCpa.AriParser).fromString(maybeAri, $25dcc7d0ac4036c1$var$blocksSnippetAriStaticOpts);
        return new _BlocksSnippetAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            workspaceId: this.workspaceId,
            snippetId: this.snippetId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._snippetId = opts.resourceIdSegmentValues.snippetId;
    }
};
module.exports["BlocksSnippetAri"] = $25dcc7d0ac4036c1$export$7140b52dd9778730;

});

parcelRegister("l3omf", function(module, exports) {
// src/blocks/snippet/types.ts
var $f53cc5c05a1e57d6$export$c5a78d3da90ef749 = "blocks", $f53cc5c05a1e57d6$export$38b3a184e1acf0da = "snippet";
module.exports["BlocksSnippetAriResourceOwner"] = $f53cc5c05a1e57d6$export$c5a78d3da90ef749;
module.exports["BlocksSnippetAriResourceType"] = $f53cc5c05a1e57d6$export$38b3a184e1acf0da;

});

parcelRegister("1KY81", function(module, exports) {

var $9Uer0 = parcelRequire("9Uer0");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $eINu6 = parcelRequire("eINu6");

const $ed0adc0464d1f863$export$eee09f98e5b044aa = async (accountId)=>{
    try {
        const { data: data, errors: errors } = await (0, $c0rhi.queryInterop)({
            query: (0, $9Uer0.default),
            variables: {
                accountId: accountId
            }
        });
        errors?.forEach((error)=>{
            $ed0adc0464d1f863$var$logFetchError(error);
            (0, $7Sm4c.markErrorAsHandled)(error);
        });
        const confUser = data.confluence_atlassianUser;
        if (!confUser || !confUser.accountId) return undefined;
        const avatarUrl = confUser?.photos?.find((photo)=>photo?.isPrimary)?.value;
        return {
            accountId: accountId,
            displayName: confUser.displayName,
            avatarUrl: avatarUrl
        };
    } catch (error) {
        $ed0adc0464d1f863$var$logFetchError(error);
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    }
};
const $ed0adc0464d1f863$var$logFetchError = (maybeError)=>{
    const error = maybeError instanceof Error ? maybeError : new Error(String(maybeError));
    const errorToLog = new Error(`Error when fetching Snippet owner user details: ${error?.message || JSON.stringify(error)}`);
    (0, $eINu6.reportError)(errorToLog);
};
module.exports["fetchUserInfo"] = $ed0adc0464d1f863$export$eee09f98e5b044aa;

});

parcelRegister("9Uer0", function(module, exports) {
/**
 * @generated SignedSource<<19ac3c4426f07d5dfd9a4f8b54ca6d12>>
 * @relayHash bbb2c87411a22051666b6360e62527f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b44d339a6bf3759952ce1a0aa42307668b285879915291057963230817ce525
const $45865754e2479135$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "current",
            "value": false
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "accountId"
        }
    ], v2 = {
        "alias": "accountId",
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            },
            {
                "kind": "ScalarField",
                "name": "isPrimary"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "blockServiceUserInfoQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AtlassianUser",
                    "kind": "LinkedField",
                    "name": "confluence_atlassianUser",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "blockServiceUserInfoQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AtlassianUser",
                    "kind": "LinkedField",
                    "name": "confluence_atlassianUser",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "bbb2c87411a22051666b6360e62527f5",
            "id": "2b44d339a6bf3759952ce1a0aa42307668b285879915291057963230817ce525",
            "metadata": {},
            "name": "blockServiceUserInfoQuery",
            "operationKind": "query",
            "text": "query blockServiceUserInfoQuery($accountId:ID!){confluence_atlassianUser(current:false,id:$accountId){accountId:id,displayName,photos{value,isPrimary},id}}"
        }
    };
}();
$45865754e2479135$var$node.hash = "6eeb5158626c73d650c7319d47b0b2c0";
var $45865754e2479135$export$2e2bcd8739ae039 = $45865754e2479135$var$node;
module.exports["default"] = $45865754e2479135$export$2e2bcd8739ae039;

});

parcelRegister("3kq4s", function(module, exports) {
let $99c76de5da631a51$var$fetchSnippetsPromise = null;
let $99c76de5da631a51$var$cachedSnippets = null;
const $99c76de5da631a51$export$cf490a717245d06 = (fetcher)=>{
    if ($99c76de5da631a51$var$fetchSnippetsPromise) return $99c76de5da631a51$var$fetchSnippetsPromise;
    if ($99c76de5da631a51$var$cachedSnippets !== null) return Promise.resolve($99c76de5da631a51$var$cachedSnippets);
    $99c76de5da631a51$var$fetchSnippetsPromise = (async ()=>{
        try {
            const result = await fetcher();
            $99c76de5da631a51$var$cachedSnippets = result;
            return result;
        } finally{
            $99c76de5da631a51$var$fetchSnippetsPromise = null;
        }
    })();
    return $99c76de5da631a51$var$fetchSnippetsPromise;
};
const $99c76de5da631a51$export$88e3986896305eb8 = ()=>{
    $99c76de5da631a51$var$cachedSnippets = null;
    $99c76de5da631a51$var$fetchSnippetsPromise = null;
};
module.exports["withSnippetsCache"] = $99c76de5da631a51$export$cf490a717245d06;
module.exports["clearSnippetsCache"] = $99c76de5da631a51$export$88e3986896305eb8;

});

parcelRegister("edTDY", function(module, exports) {
const $7169ed339831433e$export$f215cb69de957178 = (flags, title, description)=>{
    if (!flags) return;
    flags.showSuccessFlag({
        title: title,
        description: description ?? '',
        isAutoDismiss: true
    });
};
const $7169ed339831433e$export$41b17d176beb3ddb = (flags, title, description)=>{
    if (!flags) return;
    flags.showErrorFlag({
        title: title,
        description: description ?? '',
        isAutoDismiss: true
    });
};
module.exports["showSnippetSuccessFlag"] = $7169ed339831433e$export$f215cb69de957178;
module.exports["showSnippetErrorFlag"] = $7169ed339831433e$export$41b17d176beb3ddb;

});

parcelRegister("kZ6BG", function(module, exports) {
/**
 * Delete Actions - Snippet deletion with local state update
 *
 * Calls the Block Service API to delete the snippet, then removes it from
 * the react-sweet-state store so the UI updates immediately, and from the
 * quick insert menu when editor API is provided in options. When options (flags, intl)
 * are provided, shows success/error flags like createActions.
 */ 
var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3e10B = parcelRequire("3e10B");


var $64ncc = parcelRequire("64ncc");

const $182883078d656055$var$reportError = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
};
const $182883078d656055$var$displaySuccessFlag = (flags, intl, snippetName)=>{
    flags.showSuccessFlag({
        title: intl.formatMessage((0, $64ncc.messages).deleteTemplateModalSuccessFlagTitle, {
            snippetName: snippetName
        }),
        description: intl.formatMessage((0, $64ncc.messages).deleteTemplateModalSuccessFlagDescription),
        isAutoDismiss: true
    });
};
const $182883078d656055$var$displayErrorFlag = (flags, intl)=>{
    flags.showErrorFlag({
        title: intl.formatMessage((0, $64ncc.messages).deleteTemplateModalErrorFlagTitle),
        description: intl.formatMessage((0, $64ncc.messages).deleteTemplateModalErrorFlagDescription),
        isAutoDismiss: true
    });
};
const $182883078d656055$export$78632900ecc05c19 = {
    /**
   * Deletes a snippet by ID.
   *
   * - Calls the Block Service API with DELETE
   * - On success: removes the snippet from local state and from quick insert menu; shows success flag if options provided
   * - On error: reports to monitoring, shows error flag if options provided, then re-throws
   *
   * @param snippetId - The snippet ID (uuidv7) to delete
   * @param options - Optional flags and intl for success/error UI feedback
   */ deleteSnippet: (snippetId, options)=>async ({ getState: getState, setState: setState })=>{
            try {
                await $3e10B.deleteSnippet(snippetId);
                const { snippets: snippets } = getState();
                const deletedSnippet = snippets.find((s)=>s.snippetId === snippetId);
                setState({
                    snippets: snippets.filter((s)=>s.snippetId !== snippetId)
                });
                if (options && deletedSnippet) $182883078d656055$var$displaySuccessFlag(options.flags, options.intl, deletedSnippet.name);
                const editorAPI = options?.editorAPI ?? null;
                const removeQuickInsertItem = editorAPI?.quickInsert?.commands?.removeQuickInsertItem ?? null;
                if (removeQuickInsertItem) editorAPI?.core?.actions.execute(removeQuickInsertItem(`snippet-extension:snippet-${snippetId}`));
            } catch (thrownError) {
                const err = thrownError instanceof Error ? thrownError : new Error(String(thrownError));
                $182883078d656055$var$reportError(err);
                if (options) $182883078d656055$var$displayErrorFlag(options.flags, options.intl);
                throw err;
            }
        }
};
module.exports["deleteActions"] = $182883078d656055$export$78632900ecc05c19;

});

parcelRegister("64ncc", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $162407a1315c44c9$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    deleteTemplateModalTitle: {
        id: "snippets.deleteTemplateModalTitle",
        defaultMessage: "Delete this template?"
    },
    deleteTemplateModalBody: {
        id: "snippets.deleteTemplateModalBody",
        defaultMessage: "It will no longer appear in search or My templates"
    },
    deleteTemplateModalCancelButton: {
        id: "snippets.deleteTemplateModalCancelButton",
        defaultMessage: "Cancel"
    },
    deleteTemplateModalConfirmButton: {
        id: "snippets.deleteTemplateModalConfirmButton",
        defaultMessage: "Confirm"
    },
    deleteTemplateModalSuccessFlagTitle: {
        id: "snippets.deleteTemplateModalSuccessFlagTitle",
        defaultMessage: "Template \"{snippetName}\" deleted"
    },
    deleteTemplateModalSuccessFlagDescription: {
        id: "snippets.deleteTemplateModalSuccessFlagDescription",
        defaultMessage: "The template has been removed"
    },
    deleteTemplateModalErrorFlagTitle: {
        id: "snippets.deleteTemplateModalErrorFlagTitle",
        defaultMessage: "Could not delete template"
    },
    deleteTemplateModalErrorFlagDescription: {
        id: "snippets.deleteTemplateModalErrorFlagDescription",
        defaultMessage: "Please try again"
    }
});
module.exports["messages"] = $162407a1315c44c9$export$defe85febe8b728c;

});

parcelRegister("2Qxf3", function(module, exports) {
/**
 * Fetch Actions - Data fetching and cache management for snippets
 *
 * These actions handle data fetching and cache management.
 * They interact with the blockServiceClient to make API calls and update the store.
 *
 * Key behaviors:
 * - fetchSnippets: Implements request deduplication via isLoaded/isLoading flags
 * - clearCache: Resets the store to allow fresh data on next fetch
 *
 * For snippet creation with UI feedback, see createActions.ts
 */ 
var $3e10B = parcelRequire("3e10B");


var $3kq4s = parcelRequire("3kq4s");


var $eINu6 = parcelRequire("eINu6");


var $dZUkS = parcelRequire("dZUkS");

/**
 * Handles error reporting for fetch actions.
 * Sets fetchError state, reports to monitoring, and re-throws.
 */ const $bd8808f2d9e2200a$var$handleError = (error, setState, resetIsLoaded = true)=>{
    const err = error instanceof Error ? error : new Error(String(error));
    setState({
        isLoading: false,
        fetchError: err,
        ...resetIsLoaded && {
            isLoaded: false
        }
    });
    (0, $eINu6.reportError)(err);
    throw err;
};
const $bd8808f2d9e2200a$export$4286ff85d0f23d31 = {
    /**
   * Fetches snippets from the server.
   *
   * Implements request deduplication: if snippets are already loaded (isLoaded=true)
   * or a request is in progress (isLoading=true), returns cached data immediately.
   * This allows multiple components to call fetchSnippets() without causing
   * redundant API requests.
   *
   * @returns Promise resolving to the snippets array
   */ fetchSnippets: ()=>async ({ getState: getState, setState: setState })=>{
            const { isLoaded: isLoaded, isLoading: isLoading } = getState();
            // Request deduplication: return cached data if already loaded or currently loading
            if (isLoaded || isLoading) return getState().snippets;
            setState({
                isLoading: true,
                fetchError: null
            });
            try {
                const snippets = await $3e10B.fetchSnippets();
                setState({
                    snippets: snippets,
                    isLoading: false,
                    fetchError: null,
                    isLoaded: true
                });
                // Invoke any one-time callbacks registered while this fetch was in progress
                (0, $dZUkS.invokePendingLoadCallbacks)(snippets);
                return snippets;
            } catch (thrownError) {
                return $bd8808f2d9e2200a$var$handleError(thrownError, setState, true);
            }
        },
    /**
   * Clears both the service cache and store state.
   *
   * Use this when you need to force a fresh fetch on the next request,
   * such as after external changes to snippets data.
   */ clearCache: ()=>({ setState: setState })=>{
            (0, $3kq4s.clearSnippetsCache)();
            setState({
                snippets: [],
                isLoaded: false
            });
        }
};
module.exports["fetchActions"] = $bd8808f2d9e2200a$export$4286ff85d0f23d31;

});

parcelRegister("cfxyE", function(module, exports) {
/**
 * Update Actions - Snippet editing with UI integration
 *
 * This action handles snippet updates with full UI integration:
 * - Updates the snippet via the API
 * - Shows success/error flags
 * - Updates the snippet in the editor's quick insert menu
 * - Updates the snippet in the store in place (preserves list order)
 *
 * Separated from fetchActions because it has UI dependencies (flags, intl, editor API)
 * that the pure data operations don't need.
 */ 
var $iGTD6 = parcelRequire("iGTD6");


var $3e10B = parcelRequire("3e10B");


var $eINu6 = parcelRequire("eINu6");


var $edTDY = parcelRequire("edTDY");

const $ee05d86412439e5a$export$17a216d338159b9 = {
    /**
   * Updates an existing snippet and updates the store in place (preserves list order).
   *
   * On success:
   * - Replaces the snippet in the store with the API response
   * - Shows a success flag (if options provided)
   * - Adds/updates the snippet in the quick insert menu
   *
   * On error:
   * - Reports to monitoring
   * - Shows an error flag (if options provided)
   * - Keeps existing snippets visible (doesn't reset isLoaded)
   *
   * @param snippetId - The ID of the snippet to update
   * @param name - The name of the snippet
   * @param body - The body of the snippet
   * @param description - Optional description text
   * @param options - UI options including flags, intl, and editor API
   * @returns Promise resolving to the updated snippet, or null on failure
   */ updateSnippet: (snippetId, name, body, description, options)=>async ({ getState: getState, setState: setState })=>{
            const descriptionValue = description?.trim();
            const params = {
                name: name,
                ...descriptionValue ? {
                    description: descriptionValue
                } : {},
                body: JSON.stringify(body)
            };
            try {
                const snippet = await $3e10B.updateSnippet(snippetId, params);
                const currentSnippets = getState().snippets;
                const updatedSnippets = currentSnippets.map((s)=>s.snippetId === snippet.snippetId ? snippet : s);
                setState({
                    snippets: updatedSnippets
                });
                if (options) {
                    const { flags: flags, intl: intl, editorAPI: editorAPI } = options;
                    (0, $edTDY.showSnippetSuccessFlag)(flags, intl.formatMessage((0, $iGTD6.messages).snippetEditorModalEditSuccessFlagTitle, {
                        snippetName: snippet.name
                    }), '');
                    editorAPI;
                }
                return snippet;
            } catch (thrownError) {
                const err = thrownError instanceof Error ? thrownError : new Error(String(thrownError));
                (0, $eINu6.reportError)(err);
                if (options) {
                    (0, $edTDY.showSnippetErrorFlag)(options.flags, options.intl.formatMessage((0, $iGTD6.messages).snippetEditorModalEditErrorFlagTitle), options.intl.formatMessage((0, $iGTD6.messages).snippetEditorModalEditErrorFlagDescription));
                    return null;
                }
                throw err;
            }
        }
};
module.exports["updateActions"] = $ee05d86412439e5a$export$17a216d338159b9;

});

parcelRegister("iGTD6", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $808a8c85644a7933$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    snippetEditorModalTitleCreate: {
        id: "snippets.snippetEditorModal.titleCreate",
        defaultMessage: "Create block template"
    },
    snippetEditorModalTitleEdit: {
        id: "snippets.snippetEditorModal.titleEdit",
        defaultMessage: "Edit block template"
    },
    snippetEditorModalNameLabel: {
        id: "snippets.snippetEditorModal.nameLabel",
        defaultMessage: "Template Name"
    },
    snippetEditorModalNamePlaceholder: {
        id: "snippets.snippetEditorModal.namePlaceholder",
        defaultMessage: "Enter template name"
    },
    snippetEditorModalNameError: {
        id: "snippets.snippetEditorModal.nameError",
        defaultMessage: "Name is required"
    },
    snippetEditorModalDescriptionLabel: {
        id: "snippets.snippetEditorModal.descriptionLabel",
        defaultMessage: "Description"
    },
    snippetEditorModalDescriptionPlaceholder: {
        id: "snippets.snippetEditorModal.descriptionPlaceholder",
        defaultMessage: "Enter template description"
    },
    snippetEditorModalAdfError: {
        id: "snippets.snippetEditorModal.adfError",
        defaultMessage: "Something went wrong, please make a new content selection"
    },
    snippetEditorModalCancelButton: {
        id: "snippets.snippetEditorModal.cancelButton",
        defaultMessage: "Cancel"
    },
    snippetEditorModalCreateButton: {
        id: "snippets.snippetEditorModal.createButton",
        defaultMessage: "Create"
    },
    snippetEditorModalSaveButton: {
        id: "snippets.snippetEditorModal.saveButton",
        defaultMessage: "Save"
    },
    snippetEditorModalEditSuccessFlagTitle: {
        id: "snippets.snippetEditorModal.editSuccessFlagTitle",
        defaultMessage: "Template \"{snippetName}\" updated"
    },
    snippetEditorModalEditErrorFlagTitle: {
        id: "snippets.snippetEditorModal.editErrorFlagTitle",
        defaultMessage: "Could not update the template"
    },
    snippetEditorModalEditErrorFlagDescription: {
        id: "snippets.snippetEditorModal.editErrorFlagDescription",
        defaultMessage: "Please try again"
    }
});
module.exports["messages"] = $808a8c85644a7933$export$defe85febe8b728c;

});


//# sourceMappingURL=InvalidExtension.22f8d2d6.js.map
